import {createAction} from "redux-act";
import {IError, IPostContactForm} from "modules/types";

export const postContactForm = createAction<IPostContactForm>();
export const postContactFormSuccess = createAction();
export const postContactFormFailed = createAction<IError>();

export const resetContactForm = createAction();
